var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVanLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 44,
    viewBox: "0 0 45 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.333344,
    width: 44,
    height: 44,
    rx: 22,
    fill: "#FFEAE9"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M32.3333 23V21H27.6333C26.8888 21 26.5165 21 26.2153 20.9021C25.6064 20.7043 25.129 20.2269 24.9312 19.618C24.8333 19.3168 24.8333 18.9445 24.8333 18.2C24.8333 17.0832 24.8333 16.5248 24.6865 16.0729C24.3897 15.1596 23.6737 14.4436 22.7604 14.1468C22.3085 14 21.7501 14 20.6333 14H12.3333L12.3609 25C12.4156 26.0967 12.5787 26.7809 13.0656 27.2678C13.5524 27.7546 14.2366 27.9178 15.3333 27.9724C15.3481 26.8806 16.238 26 17.3333 26C18.4379 26 19.3333 26.8954 19.3333 28H25.3333C25.3333 26.8954 26.2287 26 27.3333 26C28.4287 26 29.3184 26.8806 29.3331 27.9725C30.4298 27.9178 31.1142 27.7546 31.6011 27.2678C32.3333 26.5355 32.3333 25.357 32.3333 23Z",
    fill: "#FF4444"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.3333 27.9724C14.2366 27.9178 13.5524 27.7546 13.0656 27.2678C12.5787 26.7809 12.4156 26.0967 12.3609 25M19.3333 28H25.3333M29.3333 27.9724C30.43 27.9178 31.1142 27.7546 31.6011 27.2678C32.3333 26.5355 32.3333 25.357 32.3333 23V21H27.6333C26.8888 21 26.5165 21 26.2153 20.9021C25.6064 20.7043 25.129 20.2269 24.9312 19.618C24.8333 19.3168 24.8333 18.9445 24.8333 18.2C24.8333 17.0832 24.8333 16.5248 24.6865 16.0729C24.3897 15.1596 23.6737 14.4436 22.7604 14.1468C22.3085 14 21.7501 14 20.6333 14H12.3333",
    stroke: "#172B4D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M27.3333 30C28.4379 30 29.3333 29.1046 29.3333 28C29.3333 26.8954 28.4379 26 27.3333 26C26.2288 26 25.3333 26.8954 25.3333 28C25.3333 29.1046 26.2288 30 27.3333 30Z",
    stroke: "#172B4D",
    strokeWidth: 1.5
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17.3333 30C18.4379 30 19.3333 29.1046 19.3333 28C19.3333 26.8954 18.4379 26 17.3333 26C16.2288 26 15.3333 26.8954 15.3333 28C15.3333 29.1046 16.2288 30 17.3333 30Z",
    stroke: "#172B4D",
    strokeWidth: 1.5
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M12.3333 18H18.3333",
    stroke: "#172B4D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M12.3333 21H16.3333",
    stroke: "#172B4D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M24.8333 16H26.6545C28.1099 16 28.8375 16 29.4297 16.3537C30.0219 16.7074 30.3669 17.3481 31.0569 18.6295L32.3333 21",
    stroke: "#172B4D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVanLogo);
export default __webpack_public_path__ + "static/media/van-logo.a1a747c5ca65a9327824d35025346f39.svg";
export { ForwardRef as ReactComponent };